import React from 'react';
import { Signal } from '@/api/types';
import { useTelegram } from '@/hooks';

interface DeleteConfirmationProps {
  signal: Signal;
  isOpen: boolean;
  isLoading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteConfirmation: React.FC<DeleteConfirmationProps> = ({
  signal,
  isOpen,
  isLoading,
  onConfirm,
  onCancel,
}) => {
  const { impactOccurred } = useTelegram();

  if (!isOpen) return null;

  const handleConfirm = () => {
    impactOccurred('heavy');
    onConfirm();
  };

  const handleCancel = () => {
    impactOccurred('light');
    onCancel();
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        zIndex: 1000,
        padding: '16px',
      }}
      onClick={handleCancel}
    >
      <div
        style={{
          backgroundColor: 'var(--tg-theme-bg-color)',
          borderRadius: '16px',
          width: '100%',
          maxWidth: '400px',
          overflow: 'hidden',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ padding: '24px 20px', textAlign: 'center' }}>
          <div
            style={{
              width: '56px',
              height: '56px',
              borderRadius: '50%',
              backgroundColor: 'rgba(255, 59, 48, 0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 16px',
              fontSize: '28px',
            }}
          >
            🗑️
          </div>

          <h3
            style={{
              fontSize: '18px',
              fontWeight: 600,
              color: 'var(--tg-theme-text-color)',
              margin: '0 0 8px',
            }}
          >
            Delete Alert?
          </h3>

          <p
            style={{
              fontSize: '14px',
              color: 'var(--tg-theme-hint-color)',
              margin: 0,
              lineHeight: 1.4,
            }}
          >
            Are you sure you want to delete the alert for{' '}
            <strong style={{ color: 'var(--tg-theme-text-color)' }}>
              {signal.symbol}/{signal.quoteCurrency}
            </strong>
            ? This action cannot be undone.
          </p>
        </div>

        <div
          style={{
            display: 'flex',
            borderTop: '1px solid var(--tg-theme-secondary-bg-color)',
          }}
        >
          <button
            onClick={handleCancel}
            disabled={isLoading}
            style={{
              flex: 1,
              padding: '16px',
              fontSize: '17px',
              fontWeight: 500,
              backgroundColor: 'transparent',
              color: 'var(--tg-theme-link-color)',
              border: 'none',
              borderRight: '1px solid var(--tg-theme-secondary-bg-color)',
              cursor: 'pointer',
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            disabled={isLoading}
            style={{
              flex: 1,
              padding: '16px',
              fontSize: '17px',
              fontWeight: 600,
              backgroundColor: 'transparent',
              color: '#ff3b30',
              border: 'none',
              cursor: 'pointer',
              opacity: isLoading ? 0.5 : 1,
            }}
          >
            {isLoading ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};
